import { useCallback } from 'react';
import PropTypes from 'prop-types';

import { FormState } from 'common/entities/form/FormTypes';
import AsyncSelector from 'common/components/selectors/AsyncSelector';

import { useFormState } from 'utils/hooks';
import { getAsyncOptions, getInitialAsyncValues } from 'utils/helpers';

const Company = ({ formState, active, isOpen }) => {
  const { fields, selectField } = useFormState(formState);
  const getSelectedItems = useCallback(
    active => active.linked_organizations?.map(organization => organization?.id),
    []
  );

  const onLoadOptions = useCallback(
    async search => {
      try {
        const res = await getAsyncOptions(search, 'organizations');
        const selectedItems = getSelectedItems(active);

        const excludedItems = res.filter(option => !selectedItems.includes(option.id));

        return excludedItems;
      } catch (err) {
        console.error(err);
      }
    },
    [active, getSelectedItems]
  );

  const onDefaultOptiosn = useCallback(async () => {
    try {
      const res = await getInitialAsyncValues('organizations', null, null);
      const selectedItems = getSelectedItems(active);

      const excludedItems = res.filter(option => !selectedItems.includes(option.id));

      return excludedItems;
    } catch (err) {
      console.error(err);
    }
  }, [active, getSelectedItems]);

  return (
    <div className="d-flex flex-column">
      <AsyncSelector
        className="mb-0"
        label="Company"
        placeholder="Select Company"
        onChange={selectField('organization')}
        loadOptions={onLoadOptions}
        defaultOptions={onDefaultOptiosn}
        getOptionValue={option => option.id}
        getOptionLabel={option => option.name}
        defaultOptionsTriggerChange={isOpen}
        {...fields.organization}
      />
    </div>
  );
};

export default Company;

Company.propTypes = {
  formState: FormState,
  isOpen: PropTypes.bool,
  active: PropTypes.shape({
    id: PropTypes.number,
    parent_id: PropTypes.number,
    name: PropTypes.string,
    code: PropTypes.string
  })
};
